// Hien: 610a0db4a539cb006897e3d8
// Don: 600117c134847e00695cab0f

export default {
  idUserAssign: '600117c134847e00695cab0f',
  key: 'TA',
  type: {
    bug: 'Bug',
    task: 'Task',
  },
};
